<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      :show-save-button="false"
      unit="商品上架信息"
      title="商品详情"
      id-key="RecordId"
      :data="data"
      form-label-width="130px"
      :get-data-func="api.info"
      :save-func="() => {}"
      @create-opened="onCreateOpened"
      @details-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品名称">
              <span>{{ data.GoodsName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品编码">
              <span>{{ data.GoodsCode }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          ><el-col :span="12">
            <el-form-item label="平台分类">
              <span>{{ data.TypeplatformName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商家分类">
              <span>{{ data.TypeName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品单位">
              <span>{{ data.MainUnitName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品品牌">
              <span>{{ data.BrandName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属平台首页标签">
              <span>{{ data.LabelName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否启用阶梯单价">
              
              <span v-if="data.IfStep == 0">不启用</span>
              <span v-if="data.IfStep == 1">启用</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="data.IfStep != 1">
          <el-col :span="12">
            <el-form-item label="原价" prop="OriginalPrice"> 
              {{data.OriginalPrice}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="销售价" prop="PlatformPrice">
              {{data.PlatformPrice}} </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="24">
            <el-form-item label="数量区间">
              <div style="text-align: right; padding-bottom: 10px"></div>
              <el-table
                :data="data.PriceDtos"
                border
                style="width: 100%"
                @selection-change="selectCount"
              >
                <el-table-column type="selection" width="35" />
                <el-table-column prop="OrderId" label="序号" width="50" />

                <el-table-column prop="StartCount" label="起始数量">
                </el-table-column>
                <el-table-column prop="EndCount" label="截止数量">
                </el-table-column>

                <el-table-column prop="PlatformPrice" label="单价">
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="data.IfStep != 1">
          <el-col :span="24">
            <el-form-item label="商品属性">
              <el-table
                :data="data.AttributeEffectPrices"
                border
                style="width: 100%"
              >
                <el-table-column prop="OrderId" label="序号" width="50" />
                <el-table-column
                  prop="AttributeName"
                  label="属性名称"
                  min-width="180"
                />
                <el-table-column
                  prop="AttributeCode"
                  label="属性编码"
                  min-width="120"
                >
                </el-table-column>

                <el-table-column prop="State" label="状态" min-width="120">
                  <template slot-scope="{ row }">
                    <span v-if="row.State == 0">禁用</span>
                    <span v-if="row.State == 1">启用</span>
                  </template>
                </el-table-column>
                <el-table-column prop="OriginalPrice" label="原价" width="130">                  
                </el-table-column>

                <el-table-column
                  prop="PlatformPrice"
                  label="销售价"
                  width="140"
                >    </el-table-column>             
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="24">
            <el-form-item label="商品属性">
              <el-table
                :data="data.AttributeEffectPrices"
                border
                style="width: 100%"
              >
                <el-table-column prop="OrderId" label="序号" width="50" />
                <el-table-column
                  prop="AttributeName"
                  label="属性名称"
                  min-width="180"
                />
                <el-table-column
                  prop="AttributeCode"
                  label="属性编码"
                  min-width="120"
                >
                 
                </el-table-column>

                <el-table-column prop="State" label="状态" min-width="120">
                  <template slot-scope="{ row }">
                    <span v-if="row.State == 0">禁用</span>
                    <span v-if="row.State == 1">启用</span>
                  </template>
                </el-table-column>

                <el-table-column
                  v-for="item in data.PriceDtos"
                  :key="item.RecordId"
                  :label="item.Name"
                >
                  <template slot-scope="{ row }">
                   
                        {{row.Details.filter((x) => x.Pid == item.RecordId)
                          .length > 0
                          ? row.Details.filter((x) => x.Pid == item.RecordId)[0]
                              .PlatformPrice
                          : ''}}
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="商品图片"
              prop="GoodsCover"
            >
              <single-upload
                :upload-url="uploadPicUrl"
                v-model="data.GoodsCover"
                v-if="data.GoodsCover"
              />
            </el-form-item>
          </el-col>
        </el-row>       
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否包邮" prop="FreeShipping">
             
                <span v-if="data.FreeShipping == 1">包邮</span>
                <span  v-if="data.FreeShipping == 0">不包邮</span>
              
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="data.FreeShipping == 1">
            <el-form-item label="包邮条件" prop="FreeCondition">
              <span>{{data.FreeCondition}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="data.FreeShipping == 0">
            <el-form-item label="运费模板" prop="FreightId">
              <el-select
                v-model="data.FreightId"
                placeholder="请选择运费模板"
                clearable
                disabled
              >
                <el-option
                  v-for="(i, k) in Freights"
                  :key="k"
                  :label="i.TemplateName"
                  :value="i.RecordId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>    

        <el-row class="file-form">
          <el-col :span="24">
            <el-form-item
              label="轮播图片"
              prop="GoodsCarousel"
            >
              <div>
                <el-upload
                  class="file-up"
                  :action="host + '/api/Common/UploadPicture'"
                  list-type="picture-card"
                  :show-file-list="true"
                  accept=".jpg,.png,"
                  :on-success="
                    (res, file, fileList) => {
                      onSuccess(res, file, fileList, 'GoodsCarousels');
                    }
                  "
                  :headers="headers"
                  :file-list="GoodsCarousels"
                  :limit="10"
                  :on-preview="handlePictureCardPreview"
                  :on-exceed="onExceed"
                  :before-upload="beforePhotoUpload"
                  :on-remove="
                    (file, fileList) => {
                      fileRemove(file, fileList, 'GoodsCarousels');
                    }
                  "
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-tooltip
                  class="upload-tip"
                  effect="light"
                  content="图片格式须为jpg、png, 可上传多图"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品视频">
              <upload-video
                v-model="data.GoodsVideo"
                :upload-url="uploadVideoUrl"
                :file-size="videoSize"
                v-if="data.GoodsVideo"
              ></upload-video>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="isMB ? '' : '商品详情'"
              :label-width="isMB ? '0' : ''"
              prop="GoodsIntro"
            >
              <el-divider v-if="isMB">商品详情</el-divider>
              <editor
                ref="editor"
                v-model="data.GoodsIntro"
                :height="3000"
              ></editor>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer >
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <el-dialog :visible.sync="dialogVisible" title="查看图片" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="editDialogVisible"
      width="30%"
      append-to-body
    >
      <el-form :model="form">
        <el-form-item label="单价" label-width="80px">
          <el-input
            v-model="form.PlatformPrice"
            @input="setEdit(form)"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editDialogVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singleUpload from "@/components/common/photo/singleUpload";
import uploadVideo from "@/components/common/files/uploadVideo";
import editor from "@/components/common/editor";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singleUpload,
    uploadVideo,
    editor,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      data: {
        RecordId: 0,
        OrderId: null, //序号
        BarCode: "", //条码
        QrCode: "", //二维码
        GoodsCode: "", //编码
        GoodsName: "", //名称
        TypeId: null, //分类
        TypeName: "",
        LabelId: null, //标签
        LabelName: "", //标签
        BrandId: null, //品牌
        BrandName: "",
        IfImport: null, //是否进口商品
        GoodsModel: "", //规格型号
        MainUnitid: null, //主单位
        MainUnitName: "",
        AuxiliaryUnitid: null, //辅单位
        GoodsRemark: "", //备注
        GoodsCover: "", //封面图
        GoodsVideo: "", //视频
        GoodsCarousel: "", //轮播图
        GoodsIntro: "", //简介
        OriginalPrice: "", //商品原价
        PlatformPrice: "", //平台起步价
        VirtuallySales: null, //虚拟销量
        VirtuallyInventory: null, //虚拟库存
        VirtuallyBrowse: null, //虚拟浏览量
        RealityBrowse: null, //实际浏览量
        FreightId: null, //运费模板
        NoticeId: null, //需知模板
        FreeShipping: null, //是否包邮 - 0：不包，1：包
        FreeCondition: null, //包邮条件 - 数量
        SaleRange: "",
        ReturnIllustrate: "",
        // State: 1, //状态 - 0：停用，1：正常
        AttributeEffectPrices: [], //附带调价的属性
        DistributionPrice: null,
        OriginalPrice: null,
        PlatformPrice: null,
        TradeMode: null,
        ObtainIntegral: null,
        SettingId: null,
        IfStep: 0,
        PriceDtos: [],
        TypeplatformName: "",
      },
      Notices: [],
      Freights: [],
      Settings: [],
      GoodsCarousels: [], //轮播图列表
      headers: { Authorization: "Bearer " + this.$commonJs.getCookie("token") }, //传图片时加上token
      api: require("@/api/goods/info").default,
      freight_api: require("@/api/sale/freight").default,
      price_api: require("@/api/goods/price").default,
      notice_api: require("@/api/sale/notice").default,
      setting_api: require("@/api/sy/goodssetting").default,
      uploadPicUrl: "/api/Common/UploadPicture",
      uploadVideoUrl: "/api/Common/UploadMP4",
      dialogImageUrl: "",
      dialogVisible: false,
      rules: {
        GoodsCover: [{ required: true, message: "请上传商品封面图" }],
        //OriginalPrice: [{ required: true, message: "商品原价不能为空" }],
        //PlatformPrice: [{ required: true, message: "商品销售价不能为空" }],
        // DistributionPrice: [{ required: true, message: "分销价不能为空" }],
        FreightId: [{ required: true, message: "请选择运费模板" }],
        // NoticeId: [{ required: true, message: "请选择需知模板" }],
        FreeShipping: [{ required: true, message: "请选择是否包邮" }],
        /* FreeCondition: [{
          required: true, validator: (rule, value, callback) => {
            if (this.data.FreeShipping == 1) {
              if (!value) {
             // callback(new Error('请输入包邮条件'));  
              } else {
                callback();
              }
            } else {
              callback();
            }
          }
        }], */
      },
      DelCounts: [], //将要删除的区间
      SelectCounts: [], //选中的区间
      DelAttributeEffectPrices: [],
      editDialogVisible: false,
      form: {},
    };
  },
  computed: {
    host() {
      return window.location.origin;
    },
    videoSize() {
      return this.$store.state.user.videoSize;
    },
  },
  mounted() {
    this.freight_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.Freights = res.Data;
      }
    });
    this.notice_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.Notices = res.Data;
      }
    });
    this.setting_api.list({}).then((res) => {
      if (res.Code == 0) {
        this.Settings = res.Data;
      }
    });
  },
  methods: {
    saveEdit() {
      this.editDialogVisible = false;
    },
    change(row, item) {
      console.log(row, item);
      this.editDialogVisible = true;
      row.T = 1;
      var detail = row.Details.find((x) => x.Pid == item.RecordId);
      if (!detail) {
        this.form = {
          ...item,
          Pid: item.RecordId,
          T: 0,
          AttributeId: row.RecordId,
          PriceType: 1,
        };
        row.Details.push(this.form);
      } else {
        this.form = detail;
      }
    },
    selectCount(selection) {
      this.SelectCounts = selection;
    },
    addCount() {
      var orders = this.data.PriceDtos.map((x) => x.OrderId).sort((a, b) => {
        return b - a;
      });
      this.data.PriceDtos.push({
        Index: this.data.PriceDtos.length,
        RecordId: 0,
        OrderId: orders.length == 0 ? 0 : orders[0] + 1,
        GoodsId: this.data.RecordId, //商品
        StartCount: null, //属性名称
        EndCount: null,
        PriceType: 0,
        PlatformPrice: 0,
        T: 0,
      });
    },
    delCount() {
      if (this.SelectCounts.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.SelectCounts.forEach((x) => {
        if (x.T != 0) {
          this.DelCounts.push({ ...x, T: 2 });
        }
        this.data.PriceDtos.splice(x.Index, 1);
      });
      //清空选中的数据
      this.SelectCounts = [];
      //对序号进行重新排序
      this.data.PriceDtos.forEach((x, i) => (x.Index = i));
    },
    setCount() {
      if (this.data.PriceDtos.length == 0) {
        this.$message.warning("请添加数量区间的数据");
        return;
      }
      var dtos = this.DelCounts.concat(this.data.PriceDtos);
      this.loading();
      this.price_api.saveAll(dtos).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          if (res.Data) {
            this.data.PriceDtos = res.Data;
            this.data.PriceDtos.forEach((x) => {
              x.T = 3;
            });
            var attributeEffectPrices = this.data.AttributeEffectPrices;
            attributeEffectPrices.forEach((item) => {
              item.T = 1;
              if (item.Details.length > 0) {
                item.Details.forEach((x) => {
                  var priceDto = this.data.PriceDtos.find(
                    (w) =>
                      (w.StartCount == x.StartCount &&
                        w.EndCount == x.EndCount) ||
                      w.RecordId == x.Pid
                  );
                  if (priceDto) {
                    if (priceDto.RecordId != x.Pid) {
                      x.Pid = priceDto.RecordId;
                    }
                    x.PlatformPrice = priceDto.PlatformPrice;
                    x.StartCount = priceDto.StartCount;
                    x.T = 1;
                  } else {
                    this.DelAttributeEffectPrices.push(x);
                  }
                });
              } else {
                this.data.PriceDtos.forEach((x) => {
                  item.Details.push({
                    ...x,
                    Pid: x.RecordId,
                    T: 0,
                    AttributeId: item.RecordId,
                    PriceType: 1,
                  });
                });
              }
            });
            this.data.AttributeEffectPrices = attributeEffectPrices;
            console.log(
              this.data.AttributeEffectPrices,
              "AttributeEffectPrices"
            );
          }
        } else {
          this.$message.warning(res.Msg);
          return;
        }
      });
    },
    handleFocus(data, type = 0) {
      if (type == 0) {
        if (data.OriginalPrice == 0) {
          data.OriginalPrice = null;
        }
      } else if (type == 1) {
        if (data.PlatformPrice == 0) {
          data.PlatformPrice = null;
        }
      }
    },
    handleBlur(data, type = 0) {
      if (type == 0) {
        if (data.OriginalPrice == null) {
          data.OriginalPrice = data.OriginalPrice_old;
        }
      } else if (type == 1) {
        if (data.PlatformPrice == null) {
          data.PlatformPrice = data.PlatformPrice_old;
        }
      }
    },
    onCreateOpened(row) {},
    onEditOpened(data) {
      console.log(data,"data")
      if (data.GoodsCarousel) {
        data.GoodsCarousel.split(",").forEach((e) => {
          this.GoodsCarousels.push({ url: "/api" + e, url2: e });
        });
      }
      if (data.PriceDtos) {
        data.PriceDtos.forEach((x) => {
          x.T = 3;
        });
      }
      if (data.AttributeEffectPrices) {
        data.AttributeEffectPrices.forEach((x) => {
          x.T = 3;
          x.Details.forEach((item) => {
            item.T = 3;
          });
        });
      }
    },
    setEdit(row) {
      if (row.T != 0) {
        row.T = 1;
      }
    },
    changeInventory(row) {
      this.setEdit(row);

      this.data.VirtuallyInventory;
      var arr = this.data.AttributeEffectPrices.reduce(function (acc, obj) {
        return Number(acc || 0) + Number(obj.VirtuallyInventory || 0);
      }, 0);
      console.log(arr, "arr");
      this.data.VirtuallyInventory = Number(arr);
    },
    changePrice(type) {
      if (type) {
        console.log(this.data[type], type);
        this.data.AttributeEffectPrices.forEach((item) => {
          item.T = 1;
          // if (item[type]="")
          item[type] = this.data[type];
        });
      }
    },
    onBeforeSave() {
      if (!this.GoodsCarousels.length) {
        this.$message.error("请上传轮播图片");
        return false;
      }

      // if (this.data.AttributeEffectPrices.some((x) => !x.DistributionPrice)) {
      //   this.$message.warning("分销价不能为空");
      //   return false;
      // }

      // if (this.data.AttributeEffectPrices.some((x) => !x.OriginalPrice)) {
      //   this.$message.warning("原价不能为空");
      //   return false;
      // }

      // if (this.data.AttributeEffectPrices.some((x) => !x.PlatformPrice)) {
      //   this.$message.warning("销售价不能为空");
      //   return false;
      // }
      // if (this.data.AttributeEffectPrices.some((x) => !x.VirtuallyInventory)) {
      //   this.$message.warning("虚拟库存不能为空");
      //   return false;
      // }

      var data = JSON.parse(JSON.stringify(this.data));
      data = this.$commonJs.obj.removeNullKey(data);
      data.GoodsCarousel = this.GoodsCarousels.map((x) => x.url2).join(",");

      console.log("save", data);

      // return false;
      this.loading();
      this.api.mallGoodsSave(data).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit("close-saved");
        } else {
          this.$message.error(res.Msg);
        }
      });
      return false;
    },
    onClosed() {
      this.data.AttributeEffectPrices = [];
      this.GoodsCarousels = [];
    },
    beforePhotoUpload(file) {
      const is500k = file.size / 1024 <= 2048;
      if (!is500k) {
        this.$message.error("照片大小不能超过2M");
      }
      return is500k;
    },
    onSuccess(res, file, fileList, name) {
      if (res.Code == 0) {
        this[name].push({ url: "/api" + res.Data, url2: res.Data });
      } else {
        fileList.splice(fileList.length - 1, 1);
        this.$message.error(res.Msg);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    fileRemove(file, fileList, name) {
      var index = this[name].findIndex((x) => x.url == file.url);
      if (index > -1) {
        this[name].splice(index, 1);
      }
    },
    onExceed() {
      this.$message.error("超过上传数量限制");
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-tip {
  transform: translateY(26px);
  margin-left: 10px;
}
</style>
